import { useEffect, useState } from "react";
import { Wind, Heart, Anchor, Sparkles, Shield, Flame, Crown, Phone, Feather, Smile, Maximize2, CircleDot } from "lucide-react";
import { api } from "@/lib/apiClient";

export const RESET_STYLE = {
  breathe: { icon: Wind, accent: "#4FB6C4" },
  heart: { icon: Heart, accent: "#E39AA6" },
  drop: { icon: Anchor, accent: "#8FB98A" },
  "pre-date": { icon: Flame, accent: "#E39AA6" },
  "shake-rejection": { icon: Shield, accent: "#4FB6C4" },
  "big-moment": { icon: Sparkles, accent: "#C9A24B" },
  confidence: { icon: Crown, accent: "#C9A24B" },
  "pre-call": { icon: Phone, accent: "#4FB6C4" },
  letgo: { icon: Feather, accent: "#8FB98A" },
  smile: { icon: Smile, accent: "#C9A24B" },
  expand: { icon: Maximize2, accent: "#4FB6C4" },
  still: { icon: CircleDot, accent: "#8FB98A" },
};

export const MOOD_RESET = { Tense: "breathe", Overthinking: "drop" };

let cache = null;
export function useResetLibrary() {
  const [lib, setLib] = useState(cache);
  useEffect(() => {
    if (cache) return;
    api.get("/resets/library").then((r) => { cache = r.data.map((x) => ({ ...x, ...(RESET_STYLE[x.id] || RESET_STYLE.breathe) })); setLib(cache); }).catch(() => setLib([]));
  }, []);
  return lib;
}
